import React from "react";
import { Table, Typography } from "antd";
import { Link } from "react-router-dom";
import { Card } from "./styles";
import * as S from "./styles";
import { InventoryTransferItem } from "../../../api/transfer";

const { Title } = Typography;

interface TransferItemsProps {
  loading: boolean;
  items: InventoryTransferItem[];
  orgId: string;
}

export const TransferItems: React.FC<TransferItemsProps> = ({ loading, items, orgId }) => {
  const renderLinkToProduct = (name: string, item: TransferItemsProps["items"][number]) => (
    <Link to={`/organizations/${orgId}/products/${item.product.id}`}>{name}</Link>
  );
  return (
    <S.Container direction="vertical">
      <Title level={5}>Transfer Products</Title>
      <Card size="small" bordered>
        <Table
          loading={loading}
          columns={[
            {
              title: "Product Name",
              dataIndex: ["product", "name"],
              width: "20%",
              ellipsis: true,
              render: renderLinkToProduct,
            },
            { title: "SKU", dataIndex: ["product", "sku"] },
            { title: "Requested", dataIndex: "requested" },
            { title: "Sent", dataIndex: "sent" },
            { title: "Received", dataIndex: "received" },
          ]}
          dataSource={items || []}
          rowKey={(t) => t.product.id}
          pagination={false}
        />
      </Card>
    </S.Container>
  );
};
